var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.sortedSteps.length > 0)?_c('div',{staticClass:"stamp-table-wrapper"},[(_setup.hasMixedTypes)?_c('div',{staticClass:"stamp-table-split"},[_c('table',{staticClass:"stamp-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"stamp-label",attrs:{"rowspan":4}},[_c('span',{staticClass:"vertical-text"},[_vm._v("합의")])]),_vm._l((_setup.agreementSteps),function(step){return _c('td',{key:`pos-a-${step.id}`,class:[
              'stamp-cell',
              'stamp-position',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.positionName(step) || "\u00a0")+" ")])})],2),_c('tr',_vm._l((_setup.agreementSteps),function(step){return _c('td',{key:`name-a-${step.id}`,class:[
              'stamp-cell',
              'stamp-name',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.approverName(step))+" ")])}),0),_c('tr',_vm._l((_setup.agreementSteps),function(step){return _c('td',{key:`status-a-${step.id}`,class:[
              'stamp-cell',
              'stamp-status',
              step.id === _vm.pendingStepId && 'stamp-action',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ],style:(step.id !== _vm.pendingStepId
                ? { color: _setup.statusColor(step.status) }
                : undefined),on:{"click":function($event){step.id === _vm.pendingStepId
                ? _setup.emit('click:action', step)
                : undefined}}},[(step.id === _vm.pendingStepId)?_c('span',{staticClass:"stamp-action-chip"},[_vm._v("승인하기")]):[_vm._v(_vm._s(_setup.statusLabel(step)))]],2)}),0),_c('tr',_vm._l((_setup.agreementSteps),function(step){return _c('td',{key:`datetime-a-${step.id}`,class:[
              'stamp-cell',
              'stamp-date',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.formatDecidedAt(step) || "\u00a0")+" ")])}),0)])]),_c('table',{staticClass:"stamp-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"stamp-label",attrs:{"rowspan":4}},[_c('span',{staticClass:"vertical-text"},[_vm._v("결재")])]),_vm._l((_setup.draftApprovalSteps),function(step){return _c('td',{key:`pos-d-${step.id}`,class:[
              'stamp-cell',
              'stamp-position',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.positionName(step) || "\u00a0")+" ")])})],2),_c('tr',_vm._l((_setup.draftApprovalSteps),function(step){return _c('td',{key:`name-d-${step.id}`,class:[
              'stamp-cell',
              'stamp-name',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.approverName(step))+" ")])}),0),_c('tr',_vm._l((_setup.draftApprovalSteps),function(step){return _c('td',{key:`status-d-${step.id}`,class:[
              'stamp-cell',
              'stamp-status',
              step.id === _vm.pendingStepId && 'stamp-action',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ],style:(step.id !== _vm.pendingStepId
                ? { color: _setup.statusColor(step.status) }
                : undefined),on:{"click":function($event){step.id === _vm.pendingStepId
                ? _setup.emit('click:action', step)
                : undefined}}},[(step.id === _vm.pendingStepId)?_c('span',{staticClass:"stamp-action-chip"},[_vm._v("승인하기")]):[_vm._v(_vm._s(_setup.statusLabel(step)))]],2)}),0),_c('tr',_vm._l((_setup.draftApprovalSteps),function(step){return _c('td',{key:`datetime-d-${step.id}`,class:[
              'stamp-cell',
              'stamp-date',
              step.id !== _vm.pendingStepId &&
                step.id === _vm.myStepId &&
                'stamp-my-step',
            ]},[_vm._v(" "+_vm._s(_setup.formatDecidedAt(step) || "\u00a0")+" ")])}),0)])])]):_c('table',{staticClass:"stamp-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"stamp-label",attrs:{"rowspan":4}},[_c('span',{staticClass:"vertical-text"},[_vm._v(_vm._s(_setup.agreementSteps.length > 0 ? "합의" : "결재"))])]),_vm._l((_setup.sortedSteps),function(step){return _c('td',{key:`pos-${step.id}`,class:[
            'stamp-cell',
            'stamp-position',
            step.id !== _vm.pendingStepId &&
              step.id === _vm.myStepId &&
              'stamp-my-step',
          ]},[_vm._v(" "+_vm._s(_setup.positionName(step) || "\u00a0")+" ")])})],2),_c('tr',_vm._l((_setup.sortedSteps),function(step){return _c('td',{key:`name-${step.id}`,class:[
            'stamp-cell',
            'stamp-name',
            step.id !== _vm.pendingStepId &&
              step.id === _vm.myStepId &&
              'stamp-my-step',
          ]},[_vm._v(" "+_vm._s(_setup.approverName(step))+" ")])}),0),_c('tr',_vm._l((_setup.sortedSteps),function(step){return _c('td',{key:`status-${step.id}`,class:[
            'stamp-cell',
            'stamp-status',
            step.id === _vm.pendingStepId && 'stamp-action',
            step.id !== _vm.pendingStepId &&
              step.id === _vm.myStepId &&
              'stamp-my-step',
          ],style:(step.id !== _vm.pendingStepId
              ? { color: _setup.statusColor(step.status) }
              : undefined),on:{"click":function($event){step.id === _vm.pendingStepId ? _setup.emit('click:action', step) : undefined}}},[(step.id === _vm.pendingStepId)?_c('span',{staticClass:"stamp-action-chip"},[_vm._v("승인하기")]):[_vm._v(_vm._s(_setup.statusLabel(step)))]],2)}),0),_c('tr',_vm._l((_setup.sortedSteps),function(step){return _c('td',{key:`datetime-${step.id}`,class:[
            'stamp-cell',
            'stamp-date',
            step.id !== _vm.pendingStepId &&
              step.id === _vm.myStepId &&
              'stamp-my-step',
          ]},[_vm._v(" "+_vm._s(_setup.formatDecidedAt(step) || "\u00a0")+" ")])}),0)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }